<template>
  <div class="filter-section">
    <div class="filter-row">
      <div class="filter-item">
        <span class="label">学期</span>
        <a-select v-model="filters.term" style="width: 80px" @change="handleTermChange">
          <a-select-option v-for="term in termOptions" :key="term.value" :value="term.value">
            {{ term.label }}
          </a-select-option>
        </a-select>
      </div>
      <div class="filter-item">
        <span class="label">年级</span>
        <a-select
          v-model="filters.grade"
          style="width: 80px"
          @change="handleGradeChange"
        >
          <a-select-option v-for="grade in gradeOptions" :key="grade.value" :value="grade.value">
            {{ grade.label }}
          </a-select-option>
        </a-select>
      </div>
      <div class="filter-item">
        <span class="label">班级时段</span>
        <a-select
          v-model="filters.classTime"
          style="width: 360px"
          @change="handleClassChange"
          :disabled="!filters.grade || !filters.term"
        >
          <a-select-option v-for="(cls, index) in classOptions" :key="index" :value="cls.value">
            {{ cls.label }}
          </a-select-option>
        </a-select>
      </div>

      <div class="filter-item" v-if="includeLessonSelector">
        <span class="label">讲次</span>
        <a-select
          v-model="filters.lesson"
          placeholder="请选择讲次"
          style="width: 220px"
          :disabled="!filters.classTime"
          @change="handleLessonChange"
        >
          <a-select-option v-for="lesson in lessonOptions" :key="lesson.value" :value="lesson.value">
            {{ lesson.label }}
          </a-select-option>
        </a-select>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, message } from 'ant-design-vue';
import beike from '@/service/beike';

export default {
  name: 'FilterSelector',
  components: {
    ASelect: Select,
    ASelectOption: Select.Option,
  },
  props: {
    teacherId: {
      type: [String, Number],
      default: null,
    },
    institutionId: {
      type: [String, Number],
      default: null,
    },
    roles: {
      type: Array,
      default: () => [],
    },
    includeLessonSelector: {
      type: Boolean,
      default: true,
    },
    initialFilters: {
      type: Object,
      default: () => ({
        term: '',
        grade: '',
        classTime: '',
        lesson: '',
      }),
    },
  },
  data() {
    return {
      // 筛选条件
      filters: {
        term: '',
        grade: '',
        classTime: '',
        lesson: '',
      },
      termOptions: [],
      gradeOptions: [],
      classOptions: [],
      lessonOptions: [],
      isApplyingInitialFilters: false,
    };
  },
  mounted() {
    this.getConditionData().then(() => {
      // 获取完选项后，应用初始筛选条件
      this.applyInitialFilters();
    });
  },
  methods: {
    // 获取筛选条件数据
    async getConditionData() {
      try {
        const result = await beike.getMyCondition();
        if (result) {
          const { gradeData, periodData } = result;

          // 设置年级选项 - 直接使用接口返回的数据，不添加"全部"选项
          if (gradeData && gradeData.list && Array.isArray(gradeData.list)) {
            this.gradeOptions = gradeData.list.map((item) => ({
              value: String(item.id),
              label: item.name,
            }));
          }

          // 设置学期选项 - 直接使用接口返回的数据，不添加"全部"选项
          if (periodData && periodData.list && Array.isArray(periodData.list)) {
            this.termOptions = periodData.list.map((item) => ({
              value: String(item.id),
              label: item.name,
            }));
          }
        }
      } catch (error) {
        this.$message.error('获取用户信息失败');
      }
    },
    async applyInitialFilters() {
      if (!this.initialFilters) return;
      this.isApplyingInitialFilters = true;
      // 应用学期和年级
      if (this.initialFilters.term) {
        this.filters.term = this.initialFilters.term;
      }
      if (this.initialFilters.grade) {
        this.filters.grade = this.initialFilters.grade;
      }
      // 如果有学期和年级，获取班级列表
      if (this.filters.term && this.filters.grade) {
        try {
          const params = {
            teacherId: this.teacherId || '2360496',
            gradeId: parseFloat(this.filters.grade) || 0,
            period: parseFloat(this.filters.term) || 0,
            institutionId: this.institutionId || '4155',
            roles: this.roles,
            typesId: 0,
            subjectId: 0,
          };
          await this.getBkClassList(params);
          // 应用班级时段
          if (this.initialFilters.classTime && this.classOptions.length > 0) {
            this.filters.classTime = this.initialFilters.classTime;
            // 如果需要讲次选择器且有班级，获取讲次列表
            if (this.includeLessonSelector && this.filters.classTime) {
              await this.handleClassChange();
              // 应用讲次
              if (this.initialFilters.lesson && this.lessonOptions.length > 0) {
                this.filters.lesson = this.initialFilters.lesson;
              }
            }
          }
        } catch (error) {
          console.error('应用初始筛选条件失败', error);
        }
      }
      this.isApplyingInitialFilters = false;
      // 触发筛选条件变化事件
      this.emitFilterChange();
    },
    // 处理学期变化
    async handleTermChange() {
      // 清空相关字段
      this.filters.classTime = '';
      this.filters.lesson = '';
      this.lessonOptions = [];
      this.classOptions = [];

      try {
        // 确保年级已选择
        if (this.filters.grade) {
          const params = {
            teacherId: this.teacherId || '2360496',
            gradeId: parseFloat(this.filters.grade) || 0,
            period: parseFloat(this.filters.term) || 0,
            institutionId: this.institutionId || '4155',
            roles: this.roles,
            typesId: 0,
            subjectId: 0,
          };
          await this.getBkClassList(params);
        }

        // 触发筛选条件变化事件
        this.emitFilterChange();
      } catch (error) {
        message.error('获取班级列表失败');
      }
    },

    // 处理年级变化
    async handleGradeChange() {
      // 清空相关字段
      this.filters.classTime = '';
      this.filters.lesson = '';
      this.lessonOptions = [];
      this.classOptions = [];

      try {
        const params = {
          teacherId: this.teacherId || '2360496',
          gradeId: parseFloat(this.filters.grade) || 0,
          period: parseFloat(this.filters.term) || 0,
          institutionId: this.institutionId || '4155',
          roles: this.roles,
          typesId: 0,
          subjectId: 0,
        };
        await this.getBkClassList(params);

        // 触发筛选条件变化事件
        this.emitFilterChange();
      } catch (error) {
        message.error('获取班级列表失败');
      }
    },

    // 获取班级列表
    async getBkClassList(params) {
      try {
        const result = await beike.getBkClassList(params);
        // 检查返回结果 - 根据实际数据结构进行调整
        if (result && result.list && Array.isArray(result.list)) {
          this.classOptions = result.list.map((item) => {
            const valueObj = {
              classId: item.classId,
              type: item.type,
              newDiyFlag: item.newDiyFlag,
              className: item.name,
            };
            return {
              value: JSON.stringify(valueObj),
              label: `${item.name} ${item.teachingTimes && item.teachingTimes.length > 0
                ? `${item.teachingTimes[0].beginTimeStr}-${item.teachingTimes[0].endTimeStr}`
                : ''}`,
              originalData: item,
            };
          });

          // 触发班级列表加载完成事件
          this.$emit('classes-loaded', this.classOptions);
        } else {
          message.error('获取班级列表失败：数据格式异常');
        }
      } catch (error) {
        message.error('获取班级列表失败');
        throw error;
      }
    },

    // 处理班级变化
    async handleClassChange() {
      // 清空讲次选择
      this.filters.lesson = '';
      this.lessonOptions = [];

      try {
        // 解析字符串为对象
        if (!this.filters.classTime) {
          return;
        }

        const classValue = JSON.parse(this.filters.classTime);
        // 获取选中的班级信息
        const selectedClass = this.classOptions.find((cls) => {
          const clsValue = JSON.parse(cls.value);
          return clsValue.classId === classValue.classId;
        });

        if (!selectedClass) {
          return;
        }

        // 触发筛选条件变化事件
        this.emitFilterChange();

        // 如果不需要讲次选择器，则不获取讲次列表
        if (!this.includeLessonSelector) {
          return;
        }

        const { classId, type, newDiyFlag } = classValue;
        const params = {
          businessId: classId,
          type,
          newDiyFlag,
        };

        const lessonResult = await beike.getBkLessonList(params);
        let lessons = [];

        if (lessonResult && Array.isArray(lessonResult)) {
          lessons = lessonResult;
        } else {
          message.error('获取讲次列表失败：数据格式异常');
          return;
        }

        // 处理讲次数据
        this.lessonOptions = lessons.map((lesson) => ({
          value: lesson.lessonId,
          label: lesson.lessonName || `第${lesson.lessonNum}讲`,
          originalData: lesson,
          lessonNum: lesson.lessonNum,
        }));

        // 触发讲次列表加载完成事件
        this.$emit('lessons-loaded', this.lessonOptions);
      } catch (error) {
        message.error('获取讲次列表失败');
      }
    },

    // 处理讲次变化
    handleLessonChange() {
      // 触发筛选条件变化事件
      this.emitFilterChange();
    },

    // 触发筛选条件变化事件
    emitFilterChange() {
      // 如果是在应用初始筛选条件过程中，不触发事件
      if (this.isApplyingInitialFilters) return;
      // 获取当前选中学期的 label
      let termLabel = '';
      if (this.filters.term) {
        const selectedTerm = this.termOptions.find((term) => term.value === this.filters.term);
        if (selectedTerm) {
          termLabel = selectedTerm.label;
        }
      }
      let lessonNum = '';
      let lessonName = '';
      if (this.filters.lesson && this.lessonOptions && this.lessonOptions.length > 0) {
        const selectedLesson = this.lessonOptions.find((lesson) => lesson.value === this.filters.lesson);
        if (selectedLesson && selectedLesson.lessonNum) {
          lessonNum = selectedLesson.lessonNum;
          lessonName = selectedLesson.label;
        }
      }
      this.$emit('filter-change', {
        ...this.filters,
        termLabel,
        lessonNum,
        lessonName,
      });
    },

    // 重置筛选条件
    resetFilters() {
      this.filters = {
        term: '',
        grade: '',
        classTime: '',
        lesson: '',
      };
      this.classOptions = [];
      this.lessonOptions = [];
      this.emitFilterChange();
    },

    // 设置筛选条件
    setFilters(filters) {
      if (filters) {
        this.filters = { ...this.filters, ...filters };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-section {
  background: #f5f7f9;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;

  .filter-row {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .filter-item {
    display: flex;
    align-items: center;

    .label {
      margin-right: 8px;
      color: #505873;
      font-size: 14px;
    }
  }
}
</style>
